/* eslint-disable */
import InputBlock from './components/InputBlock';
import Captcha from './components/Captcha';

export default class Form {
  constructor(form, doSending, callback) {
    this.element = form;
    const { siteKey = null } = form.dataset;
    this.dosending = doSending;

    this.fields = Array.from(this.element.querySelectorAll('[data-role="input-block"]'))
      .map(field => new InputBlock(field));
    this.captcha = siteKey ? new Captcha(this.element.querySelector('[data-role="captcha-block"]'), siteKey, this.element) : { valid: true };
    this.content = this.element.querySelector('[data-role="content"]');
    this.message = this.element.querySelector('[data-role="message"]');
    this.button = this.element.querySelector('[data-role="button"]');
    this.element.addEventListener('submit', (e) => {
      this.validate(e);
    });
    $(this.element).on('submitForm', (e) => {
      this.submit(e, callback);
    })
  }

  submit(e, callback = () => {
    this.sendData();
    this.playAnimationSubmit();
  }) {
    callback();
  }

  validate(e) {
    e && e.preventDefault();
    this.fields.forEach((field) => {
      field.validate();
    });
    if (this.isValid()) {
      if (this.captcha.element) {
        this.captcha.validate();
      } else {
        $(this.element).trigger('submitForm');
      }
    } else {
      const target = this.element.querySelector('.is-invalid');
      const distance = $(target).offset().top;
      $('body, html').animate({ scrollTop: distance - 200 }, 600);
    }
  }

  isValid() {
    return this.fields.reduce((prev, curr) => prev && curr && curr.valid, true) && this.captcha.valid;
  }

  resetForm() {
    this.fields.forEach(field => field.reset());
    this.captcha.element && this.captcha.reset();
  }

  displayMessage(callback) {
    const
      $content = $(this.content),
      $message = $(this.message);
    $('body, html').animate({ scrollTop: $content.offset().top - 200 }, 600);
    $content.animate({ opacity: '0' }, 500);
    $message.animate({ opacity: '1' }, 500);
    setTimeout(this.resetForm.bind(this), 1000);
    setTimeout(() => {
      $message.animate({ opacity: '0' }, 500);
      $content.animate({ opacity: '1' }, 500);
      callback && callback();
    }, 2000);
  }

  playButton() {
    const $btn = $(this.button);
    $btn.addClass('disabled').addClass('hovered');
    $btn.children('.progress-line').css('transition-duration', `${parseInt($btn.attr('data-progress-duration'))}s`);
    $btn.children('.progress-line').addClass('is-active');
    setTimeout(() => {
      $btn.removeClass('hovered').removeClass('disabled');
      setTimeout(() => {
        $btn.children('.progress-line').removeAttr('style');
        $btn.children('.progress-line').removeClass('is-active');
      }, 100);
    }, parseInt($btn.attr('data-progress-duration')) * 1000);
  }

  playAnimationSubmit(callback) {
    this.displayMessage(callback);
    this.playButton();
  }

  sendData() {
    const $self = $(this.element);
    let ajaxData;
    console.log($self.serializeArray());
    $.post($self.attr('action'), $self.serialize(), 'json')
      .done((data) => {
        ajaxData = data;
        // can do something with data
        console.log(ajaxData);
      })
      .fail((jqXhr, status, error) => {
        console.log(status, error);
      });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/form/form.js